<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/privacypolicy",
        "headline":"Hot Linux ／ WEBシステム開発（プライバシーポリシー）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。Hot Linuxではクライアント様のプライバシーを大事にしています。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>
    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-shield-key-outline"
          bg-color="grey-lighten-4"
          rounded
        >
          <h3>プライバシーポリシー</h3>
        </v-breadcrumbs>
        <v-card v-for='(row,index) in ポリシーrtn' :key='index' class='mx-3 my-3'>
          <template v-slot:title>
            <v-list>
              <v-list-item
                :href="'https://google.com/search?q='+row.タイトル"
                target="_blank"
                style='white-space:normal'
              >
                {{row.タイトル}}
              </v-list-item>
            </v-list>
          </template>
          <v-card-text>
            {{row.内容}}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LeftSide from './LeftSide.vue'
export default {
  components: { LeftSide },
  data(){
    return {
      ポリシーrtn:[],
    }
  },
  created(){

  },
  mounted(){
    this.ポリシー取得();
  },

  methods:{
    ポリシー取得(){
      this.$emit('overlay');
      let url = './api/api.php';
      let data = {
        func:"ポリシー取得",
        pageSize:10,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.ポリシーrtn = result.ポリシーrtn;
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('取得できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },
  },

}
</script>